@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <label>{{ displayName.toUpperCase() }}</label>
    @if (isEdit && !isReadOnly) {
      <div
        fxLayout="row"
        >
        <topo-date-time-picker
          [(ngModel)]="dateValue"
          [showTime]="showTime"
          class="is-primary is-medium"
          style="width: 100%"
        [allowEmptyDateString]="true"></topo-date-time-picker>
      </div>
    } @else {
      <div class="is-readonly">{{ formattedFieldValue }}</div>
    }
  </div>
}
